import type { ReactNode } from 'react'

type StickyActionFooterProps = {
  children: ReactNode
  /** Selaraskan dengan lebar shell — delman: max-w-md, warehouse: max-w-5xl. */
  maxWidthClass?: string
}

/** Mirror superoti-kitchen/src/shared/components/StickyActionFooter.tsx (selalu di atas bottom nav). */
export function StickyActionFooter({ children, maxWidthClass = 'max-w-5xl' }: StickyActionFooterProps) {
  return (
    <div className="fixed bottom-[4.5rem] left-0 right-0 z-20 flex justify-center pointer-events-none">
      <div
        className={`w-full ${maxWidthClass} px-4 pointer-events-auto border-t border-outline-variant bg-surface-card pt-4 pb-[max(1rem,env(safe-area-inset-bottom))] shadow-[0_-4px_12px_rgba(0,0,0,0.08)]`}
      >
        <div className="flex flex-col gap-2">{children}</div>
      </div>
    </div>
  )
}
